'use strict';

let $ = window.jQuery || window.$ || require('jquery');

export default $;
